import { Row, Col, Table, Spinner } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function ServidoresCedidos() {
  const [servidores, setServidores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://dadosabertos.alepe.pe.gov.br/api/v1/servidores/?vinculo=efetivo-cedido")
      .then(result => result.json())
      .then(data => {
        setServidores(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <Row>
      <Col xs="12">
        <p>
          <small>
            Você está em <a href="/pessoal">Gestão de Pessoas</a> / Servidores Cedidos
          </small>
        </p>
      </Col>
      {!loading ? (
        <Col xs="12">
          <Row>
            <Col xs={{ span: 2, offset: 10 }} className="mb-2 text-center">
              <div>
                <a
                  href="https://dadosabertos.alepe.pe.gov.br/api/v1/servidores/?vinculo=efetivo-cedido&formato=csv"
                  title="Download em CSV"
                >
                  <img src="/img/download-csv.png" height="16" width="16" alt="" />
                  CSV
                </a>
              </div>
            </Col>
          </Row>
          <div className="table-responsive">
              <Table striped bordered hover>
                  <thead>
                      <tr>
                          <th>Nome</th>
                          <th>Cargo</th>
                          <th>Lotação</th>
                          <th>Vínculo</th>
                      </tr>
                  </thead>
                  <tbody>
                      {servidores.map((servidor, index) => (
                          <tr key={index}>
                              <td>{servidor.NOME}</td>
                              <td>{servidor.CARGO_NIVEL}</td>
                              <td>{servidor.NOME_LOTACAO}</td>
                              <td>{servidor.VINCULO}</td>
                          </tr>
                      ))}
                  </tbody>
              </Table>
          </div>
        </Col>
      ) : (
        <Col xs="12" className="text-center">
          <Spinner />
        </Col>
      )}
    </Row>
  );
}
